export default "__VITE_ASSET__Dmt4oKez__"